export default __webpack_public_path__ + "static/media/help-page-relocation-button.88747a36.jpg";